import { create } from 'zustand';
import { get } from '../../api';
import { findCurrencyByCodeIn } from '../../utils/currency';

export type Currency = {
    id: number;
    code: string;
    name: string;
    symbol: string;
};

type CurrencyStore = {
    // State
    currencies: Currency[];
    isLoading: boolean;

    // Actions
    fetchCurrencies: () => Promise<void>;
};

const useCurrencyStore = create<CurrencyStore>(set => ({
    currencies: [],
    isLoading: false,

    fetchCurrencies: async () => {
        set({ currencies: [], isLoading: true });
        try {
            const response = await get('currencies');
            set({ currencies: response.currencies ?? [], isLoading: false });
        } catch (error) {
            console.error('Failed to fetch currencies:', error);
            set({ isLoading: false });
        }
    },
}));

// Export actions for external use
export const currencyActions = {
    fetchCurrencies: () => useCurrencyStore.getState().fetchCurrencies(),
};

// Selectors
export const useCurrencies = () => useCurrencyStore(state => state.currencies);
export const useCurrenciesLoading = () => useCurrencyStore(state => state.isLoading);
export const findCurrencyByCode = (code: string | undefined | null): Currency | undefined => {
    const currencies = useCurrencyStore.getState().currencies;
    return findCurrencyByCodeIn(currencies, code);
};
export const findCurrencyById = (id: number | string | undefined | null): Currency | undefined => {
    const currencies = useCurrencyStore.getState().currencies;
    return currencies.find(c => c.id === id);
};

export default useCurrencyStore;
